import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const querySchema = z.object({
  chapter: z.string().optional(),
});

// Студия переехала в раздел учебной программы: книга и выбранная глава сохраняются
export const Route = createFileRoute('/studio/books/$bookId')({
  validateSearch: querySchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/curriculum/books/$bookId',
      params,
      search,
      replace: true,
    });
  },
});
